import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthFrame from "./AuthFrame";
import { Lockup, SocialButtons, DotNote, Divider, SecondaryBtn, Actions, InlineLink, Fine } from "./pieces";
import { readSignup, writeSignup, clearSignup } from "./signupState";
import GoogleButton from "./GoogleButton";
import { accountTypeOf, articleFor } from "./accountTypes";

// 01 · Welcome, for the account type picked on the screen before (athlete
// when the page is opened directly); Change goes back to pick another.
// Every type gets Google and the email or phone path, athletes the social
// sign-ins too. A typed email or mobile number confirms a code before the
// account exists; Google has already confirmed the email.
const WelcomePage = () => {
  const navigate = useNavigate();
  // Read once, when the page opens. The Google button writes a fresh
  // identity into the state while this page is still mounted; the guard
  // below is only for one that was already waiting.
  const [pending] = useState(readSignup);
  const type = accountTypeOf(pending.accountType);
  const google = <GoogleButton label="Google" accountType={type.key} />;

  // A Google identity waiting in the tab belongs on the type screen, which finishes it.
  useEffect(() => {
    if (pending.viaGoogle && pending.ticket) navigate("/register", { replace: true });
  }, [pending.viaGoogle, pending.ticket, navigate]);

  const continueWithEmail = () => {
    clearSignup();
    writeSignup({ accountType: type.key });
    navigate("/signup/email");
  };

  // On phones (Figma 1745:1280, 2466:18703) the lockup sits 8px under the
  // header, SocialButtons drops the disabled Instagram and TikTok, and the
  // Actions below are the sticky footer. Back stays: it is the way to the
  // type screen.
  return (
    <AuthFrame onBack={() => navigate("/register")} phoneTop="lockup">
      <Lockup tagline={type.tagline} />
      <p className="text-center bm-body-s text-bm-muted">
        Creating {articleFor(type.short)} {type.short} account ·{" "}
        <button type="button" onClick={() => navigate("/register")} className="bm-label-xs text-bm-orange hover:underline">Change</button>
      </p>
      {type.key === "IS_ATHLETE" ? (
        <>
          <SocialButtons label="Continue with" enabled={process.env.REACT_APP_SOCIAL_SIGNIN === "on"} leading={google} />
          <DotNote>Connecting a social account starts your CacheScore right away</DotNote>
        </>
      ) : (
        <div className="flex flex-col gap-[10px]">
          <p className="bm-overline">Continue with</p>
          {google}
        </div>
      )}
      <Divider />
      <SecondaryBtn onClick={continueWithEmail}>Use email or phone</SecondaryBtn>
      <Actions>
        <InlineLink text="Already have an account?" label="Log in" onClick={() => navigate("/login")} />
        <Fine>By continuing you agree to the Terms and Privacy Policy.</Fine>
      </Actions>
    </AuthFrame>
  );
};

export default WelcomePage;
